import './NestedTableView.css'

import React from "react";
import Table from "../Table/Table";

const NestedTableView = ({
                             title,
                             columns,
                             tickets,
                             totalPages,
                             isLoading,
                             page,
                             setPage,
                             onRowClick,
                             onBack
                         }: {
    title: string;
    columns: string[];
    tickets: any[];
    totalPages: number;
    isLoading: boolean;
    page: number;
    setPage: (page: number) => void;
    onRowClick?: (row: Record<string, any>) => void;
    onBack?: () => void;
}) => {
    return (
        <div className="tickets-view-container">
            <div className="nested-table-header">
                <button onClick={onBack}>REGRESAR</button>
                <div className="tickets-view-header-title">
                    <p>{title}</p>
                </div>
            </div>
            {isLoading ? (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <div className="loading-message">Obteniendo información...</div>
                </div>
            ) : (
                <div className="tickets-view-table">
                    <Table
                        columns={columns}
                        data={tickets}
                        totalPages={totalPages}
                        currentPage={page}
                        setCurrentPage={setPage}
                        onRowClick={onRowClick}
                    />
                </div>
            )}
        </div>
    );
};

export default NestedTableView;
